import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { debounce } from "lodash";
import { ChangeEvent, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import Filter from "../../components/lines-managements/header/Filter";
import HeaderPage from "../../components/lines-managements/header/HeaderPage";
import ReviewTable from "../../components/reviews";
import Input from "../../components/ui/input/Input";
import Select from "../../components/ui/select/Select";
import { defaultConfig } from "../../hooks/useSearch";
import { OperatorsSelectList } from "../../interfaces/endpoints/IOperators";
import { getAllSelectOperators } from "../../services/Operators.service";
import { cx } from "../../utils/classnames";

const defaultOperatorLocation = {
  operatorName: "All",
  id: 0
};

const Reviews: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { state } = useLocation();
  const [selectedOperator, setSelectedOperator] =
    useState<OperatorsSelectList>(defaultOperatorLocation);
  const [operatorSelectKey, setOperatorSelectKey] = useState(0);

  const ratingOptions = [
    { label: "★★★★★", id: "5" },
    { label: "★★★★", id: "4" },
    { label: "★★★", id: "3" },
    { label: "★★", id: "2" },
    { label: "★", id: "1" }
  ];

  const reviewTypeOptions = [
    { label: "Journey Reviews", id: "1" },
    { label: "eSIM Reviews", id: "2" }
  ];

  const handleOperatorChange = (operator: OperatorsSelectList) => {
    if (operator.id) {
      setSelectedOperator(operator);
      searchParams.set("operatorId", operator.id.toString());
    } else {
      setSelectedOperator(defaultOperatorLocation);
      searchParams.delete("operatorId");
      setOperatorSelectKey((prev) => prev + 1);
    }
    searchParams.delete(defaultConfig.paginationSelector);
    setSearchParams(searchParams, {
      replace: true,
      state
    });
  };

  const onSearchInput = (event: ChangeEvent<HTMLInputElement>) =>
    debouceSearch(event.currentTarget.value);

  const debouceSearch = debounce((query) => {
    if (query.length) searchParams.set(defaultConfig.querySelector, query);
    else searchParams.delete(defaultConfig.querySelector);
    searchParams.delete(defaultConfig.paginationSelector);
    setSearchParams(searchParams, {
      replace: true,
      state
    });
  }, 700);

  return (
    <>
      <HeaderPage hasNoInput={true} />
      <div className="mb-4 flex justify-end items-center">

        <Input
          className="w-auto mr-3 md:mr-6 group"
          placeholder="Kërko..."
          paddingType="fill"
          defaultValue={searchParams.get(defaultConfig.querySelector) || ""}
          onChange={onSearchInput}
          inputClassName={cx([
            "group",
            searchParams.get(defaultConfig.querySelector)?.length
              ? "w-56 pr-1"
              : "cursor-pointer sm:focus:w-56 focus:w-48 w-0 pr-1"
          ])}
          beforeClassName="text-neutral group-hover:text-black"
          before={<MagnifyingGlassIcon className="w-4 h-4" strokeWidth={2} />}
        />
         <Select
          placeholder="Filtro per Operator"
          paddingType="fill"
          onSelectedItemChange={handleOperatorChange}
          selectedItem={selectedOperator}
          getOptionLabel={(o) => o.operatorName}
          emptyItem={defaultOperatorLocation}
          itemToString={(o) => o?.operatorName || ""}
          asyncFunc={getAllSelectOperators}
          key={operatorSelectKey}
          className="w-fit "
        />
        <Filter
          filterName="Review Type"
          options={reviewTypeOptions}
          filterSelctor="reviewType"
        />
        <Filter
          filterName="Filtro Rating"
          options={ratingOptions}
          filterSelctor="rating"
        />
      </div>
      <ReviewTable />
    </>
  );
};

export default Reviews;
